import styled from 'styled-components'
import { StageExplainer } from './Explainers'
import { stageMeta } from './remedialMeta'

const StagePill = ({ stage, action = null, withExplainer = false, size = 'md' }) => {
  const meta = stageMeta(stage, action)
  return (
    <Wrap>
      <Pill data-stage={stage || 'unknown'} data-level={meta.level} $small={size === 'sm'} style={{ color: meta.color, background: meta.bg }}>
        <Dot style={{ background: meta.color }} aria-hidden='true' />
        {meta.label}
      </Pill>
      {withExplainer && <StageExplainer />}
    </Wrap>
  )
}

export default StagePill

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
`

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: ${({ $small }) => ($small ? '2px 8px' : '4px 10px')};
  border-radius: 999px;
  font-size: ${({ $small }) => ($small ? '12.5px' : '14px')};
  font-weight: 600;
  white-space: nowrap;
`

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
`
